export interface RealEstateReview {
  name: string;
  initials: string;
  color: string;
  badges: string[];
  rating: number;
  date: string;
  text: string;
  helpful: number;
}

export const realEstateReviews: Record<string, RealEstateReview[]> = {
  globallistings: [
    {
      name: 'Sarah M.',
      initials: 'SM',
      color: 'bg-fuchsia-500',
      badges: ['Verified', 'Buyer'],
      rating: 5,
      date: 'Feb 2026',
      text: "GlobalListings made finding investment properties in Portugal and Spain incredibly easy. Instead of navigating five different country-specific portals, I could search everything from one place. The filter system is excellent — I narrowed down to beachfront properties under €500K in less than 10 minutes. Found my Algarve property through this platform and I'm extremely happy.",
      helpful: 112,
    },
    {
      name: 'James K.',
      initials: 'JK',
      color: 'bg-rose-500',
      badges: ['Verified', 'Investor'],
      rating: 4,
      date: 'Jan 2026',
      text: "Really solid platform for comparing international real estate markets. The coverage across Southeast Asia and Eastern Europe is particularly good. My only feedback is that some listings in smaller markets are not always fully updated. But as a research and discovery tool for international property investment, GlobalListings is genuinely valuable and I use it regularly.",
      helpful: 87,
    },
    {
      name: 'Elena W.',
      initials: 'EW',
      color: 'bg-pink-500',
      badges: ['Verified'],
      rating: 5,
      date: 'Dec 2025',
      text: "As an expat relocating every few years, GlobalListings has become my essential first stop for housing research in new countries. The high-res photos and detailed listing information save enormous time. I've used it for searches in Dubai, Singapore, and Thailand and the coverage is excellent in all three markets. The agent contact system is also clean and reliable.",
      helpful: 98,
    },
  ],
  tranio: [
    {
      name: 'Michael P.',
      initials: 'MP',
      color: 'bg-rose-600',
      badges: ['Verified', 'Investor'],
      rating: 5,
      date: 'Feb 2026',
      text: "Tranio guided my entire European property investment journey from initial search to completed purchase. The quality of their advisory team is exceptional — they have genuine expertise in both the legal and tax implications of buying in different EU jurisdictions. I purchased an apartment in Lisbon through them and the entire process was smooth and professional. Highly recommend for international buyers.",
      helpful: 178,
    },
    {
      name: 'Lisa T.',
      initials: 'LT',
      color: 'bg-pink-600',
      badges: ['Verified', 'Golden Visa'],
      rating: 5,
      date: 'Jan 2026',
      text: "I specifically used Tranio to find qualifying properties for the Greek Golden Visa program and their expertise in this area is outstanding. They clearly explained the qualifying criteria, identified excellent investment options, and managed the entire process including legal support. The team was responsive throughout and the investment has performed beautifully. An exceptional service.",
      helpful: 145,
    },
    {
      name: 'David N.',
      initials: 'DN',
      color: 'bg-fuchsia-600',
      badges: ['Verified'],
      rating: 4,
      date: 'Nov 2025',
      text: "Really strong platform for luxury international property research. The market reports and investment analysis Tranio provides are genuinely insightful — better quality than most paid research I've seen. The buyer's agent service is worth the cost for complex cross-border transactions. Docking one star only because response times during busy periods could be faster.",
      helpful: 112,
    },
  ],
  myreipro: [
    {
      name: 'Chris B.',
      initials: 'CB',
      color: 'bg-violet-500',
      badges: ['Verified', 'Wholesaler'],
      rating: 5,
      date: 'Feb 2026',
      text: "MyREIPro is the backbone of my wholesaling business. I went from tracking leads in spreadsheets to having everything organized in one system that actually works. The deal analyzer has saved me from buying bad deals at least 3 times — I can run the numbers in 2 minutes and know exactly where I stand. Worth every penny of the monthly subscription.",
      helpful: 167,
    },
    {
      name: 'Amanda S.',
      initials: 'AS',
      color: 'bg-purple-500',
      badges: ['Verified', 'Fix & Flip'],
      rating: 4,
      date: 'Jan 2026',
      text: "Solid REI CRM with excellent deal analysis tools. The ARV calculator and repair cost estimator are particularly useful for my fix-and-flip projects. The SMS follow-up automation has significantly improved my lead response rates. A small learning curve at the beginning but the tutorial videos are helpful. Good investment for any serious real estate investor.",
      helpful: 134,
    },
    {
      name: 'Marcus D.',
      initials: 'MD',
      color: 'bg-violet-600',
      badges: ['Verified'],
      rating: 5,
      date: 'Dec 2025',
      text: "Switched from another REI CRM to MyREIPro 8 months ago and haven't looked back. The direct mail integration alone has paid for the subscription multiple times over. Being able to send campaigns, track responses, and manage follow-ups all in one platform is a game changer. The mobile app also works great for evaluating properties on the spot.",
      helpful: 112,
    },
  ],
  innago: [
    {
      name: 'Linda P.',
      initials: 'LP',
      color: 'bg-sky-500',
      badges: ['Verified', 'Landlord'],
      rating: 5,
      date: 'Feb 2026',
      text: "Innago has completely transformed how I manage my 12 rental units. Before Innago, I was chasing rent checks and managing maintenance requests through text messages. Now everything is automated — rent comes in on schedule, maintenance tickets are properly tracked, and my lease documents are all digital and signed online. And it's completely free! I honestly can't believe this is free.",
      helpful: 243,
    },
    {
      name: 'Kevin R.',
      initials: 'KR',
      color: 'bg-cyan-500',
      badges: ['Verified', 'Property Manager'],
      rating: 5,
      date: 'Jan 2026',
      text: "I manage properties for 6 different owners and Innago handles everything beautifully. The tenant portal gives residents a professional experience for paying rent and submitting maintenance requests, which has actually improved tenant satisfaction scores. The accounting reports save me hours every month. For a free tool, the feature depth is extraordinary.",
      helpful: 198,
    },
    {
      name: 'Rachel H.',
      initials: 'RH',
      color: 'bg-sky-600',
      badges: ['Verified'],
      rating: 4,
      date: 'Nov 2025',
      text: "Excellent free property management software. The online rent collection and tenant screening tools work exactly as described. Interface is clean and easy to use even for non-tech-savvy landlords. Only minor feedback: I'd like more customization options for the tenant portal and some additional reporting features. But for free, this is genuinely impressive software.",
      helpful: 134,
    },
  ],
  propertymob: [
    {
      name: 'Tony M.',
      initials: 'TM',
      color: 'bg-fuchsia-500',
      badges: ['Verified', 'Member'],
      rating: 5,
      date: 'Feb 2026',
      text: "PropertyMob completely transformed my real estate investing journey. Before joining, I'd been studying for 2 years without closing a deal. Within 3 months of the community and coaching, I closed my first wholesale deal. The live coaching calls are invaluable and the deal evaluation service gave me confidence in my first acquisition. Best real estate investment education available.",
      helpful: 178,
    },
    {
      name: 'Sandra K.',
      initials: 'SK',
      color: 'bg-pink-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Really solid real estate education platform. The course content is comprehensive and practical — real strategies that actually work in today's market, not outdated theory. The community forum is active and members genuinely help each other. I've found deal partners and learned from people with decades of experience. Monthly cost is very reasonable for the value provided.",
      helpful: 134,
    },
    {
      name: 'Jake W.',
      initials: 'JW',
      color: 'bg-rose-500',
      badges: ['Verified', 'BRRRR Investor'],
      rating: 5,
      date: 'Dec 2025',
      text: "PropertyMob's BRRRR method content is the best I've found anywhere. The instructors have actually done hundreds of deals and share real numbers and real results. The deal evaluation service is exceptional — I submitted a property and got detailed feedback within 24 hours from someone who had done similar deals in the same market. Well worth the membership cost.",
      helpful: 112,
    },
  ],
  fundingpips: [
    {
      name: 'Ryan C.',
      initials: 'RC',
      color: 'bg-emerald-600',
      badges: ['Verified', 'Funded Trader'],
      rating: 5,
      date: 'Feb 2026',
      text: "Passed my FundingPips Phase 1 and 2 challenges and received my $100K account within 3 business days. The evaluation rules are clear and fair — exactly as advertised. My first withdrawal request was processed in 48 hours, no questions asked. FundingPips has genuinely delivered on every promise they made. One of the most reputable prop firms I've worked with.",
      helpful: 198,
    },
    {
      name: 'Alice M.',
      initials: 'AM',
      color: 'bg-teal-600',
      badges: ['Verified', 'Forex Trader'],
      rating: 5,
      date: 'Jan 2026',
      text: "The challenge parameters at FundingPips are very reasonable compared to other prop firms. The profit targets are achievable without taking excessive risk, and the drawdown limits give you enough room to trade properly through market volatility. Support team is responsive and knowledgeable. I'm now on my second funded account after scaling up from $50K to $100K.",
      helpful: 145,
    },
    {
      name: 'Tom K.',
      initials: 'TK',
      color: 'bg-emerald-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Nov 2025',
      text: "Solid prop firm with competitive pricing and reliable payouts. The evaluation model is straightforward and the rules are clearly stated upfront — no hidden restrictions that trip you up after you've already paid. I passed on my second attempt after adjusting my risk management approach. The 90% profit split is excellent and payments have always arrived on time.",
      helpful: 112,
    },
  ],
  rebelsfunding: [
    {
      name: 'Mark D.',
      initials: 'MD',
      color: 'bg-red-600',
      badges: ['Verified', 'Funded Trader'],
      rating: 5,
      date: 'Feb 2026',
      text: "The no-time-limit feature at RebelsFunding is a game changer. I trade part-time around my real estate investing schedule and other prop firms' strict deadlines created pressure that hurt my performance. With RebelsFunding I could trade at my natural pace and pass the challenge on my terms. 95% profit split and my payout was processed next day. Absolutely love this firm.",
      helpful: 178,
    },
    {
      name: 'Jennifer L.',
      initials: 'JL',
      color: 'bg-rose-600',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Really impressed with RebelsFunding's trader-friendly rules. News trading allowed, scalping allowed, no time pressure — they clearly designed this for real traders, not to maximize challenge failures. Got funded on first attempt using my normal strategy. The scaling plan to $1 million is ambitious but the path is clear and achievable. Very happy customer.",
      helpful: 143,
    },
    {
      name: 'Sam T.',
      initials: 'ST',
      color: 'bg-red-500',
      badges: ['Verified', 'Scalper'],
      rating: 5,
      date: 'Dec 2025',
      text: "As a scalper, most prop firms are closed off to me because of their ridiculous trading restrictions. RebelsFunding is one of the very few that actually welcomes scalpers and doesn't penalize you for trading your natural style. Passed the challenge in 3 weeks, got funded immediately, and my payouts have been perfect every time. This is how prop firms should operate.",
      helpful: 165,
    },
  ],
  wemastertrad: [
    {
      name: 'Carlos M.',
      initials: 'CM',
      color: 'bg-indigo-500',
      badges: ['Verified', 'Student'],
      rating: 5,
      date: 'Feb 2026',
      text: "WeMasterTrade is the only prop firm that actually cares about making you a better trader, not just collecting challenge fees. The mentorship community connected me with a senior trader who reviewed my strategy and helped me identify major weaknesses. 3 months later I passed my challenge and now trade with a $100K funded account. The education ROI here is exceptional.",
      helpful: 134,
    },
    {
      name: 'Aisha K.',
      initials: 'AK',
      color: 'bg-violet-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "Really appreciate WeMasterTrade's approach of pairing education with funding. I came in as a developing trader and the community accelerated my growth significantly. The technical analysis courses are excellent quality. My one feedback is the profit split could be more competitive — 85% vs some firms offering 90-95%. But the education value makes up for it.",
      helpful: 98,
    },
    {
      name: 'Ben W.',
      initials: 'BW',
      color: 'bg-indigo-600',
      badges: ['Verified', 'Mentor'],
      rating: 4,
      date: 'Nov 2025',
      text: "I'm now a mentor in the WeMasterTrade community after trading profitably for 3 years. The quality of students coming through is high because the education filters out gamblers and attracts serious learners. Bi-weekly payouts are reliable and the trading infrastructure is solid. Good firm that genuinely wants traders to succeed.",
      helpful: 87,
    },
  ],
  sabiotrade: [
    {
      name: 'David L.',
      initials: 'DL',
      color: 'bg-amber-600',
      badges: ['Verified', 'AI Trader'],
      rating: 5,
      date: 'Feb 2026',
      text: "The AI analysis tools at SabioTrade are genuinely useful — not just marketing fluff. The sentiment analysis has improved my entry timing significantly and the correlation mapping helped me avoid over-exposure to correlated positions. Passed the challenge in 18 days using my AI-enhanced strategy. The platform feels like it was designed by people who actually trade.",
      helpful: 145,
    },
    {
      name: 'Nina P.',
      initials: 'NP',
      color: 'bg-orange-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Jan 2026',
      text: "SabioTrade is a solid prop firm with an interesting differentiator in the AI tools. The volatility forecasting feature helped me avoid trading during periods of unexpected market moves. Evaluation parameters are fair and the two-phase model is straightforward. Would give 5 stars if the profit split was higher — 80% is decent but behind leaders offering 90%+.",
      helpful: 112,
    },
    {
      name: 'James R.',
      initials: 'JR',
      color: 'bg-amber-500',
      badges: ['Verified', 'Quant Trader'],
      rating: 5,
      date: 'Nov 2025',
      text: "As a quantitative trader I appreciate data-driven tools and SabioTrade delivers. The market sentiment and correlation data integrates nicely with my systematic strategy. Three successful funding rounds, all payouts on time. Support team actually understands trading which is rare. If you trade using data and analysis, SabioTrade is the prop firm for you.",
      helpful: 98,
    },
  ],
  toptiertrader: [
    {
      name: 'Oliver M.',
      initials: 'OM',
      color: 'bg-yellow-600',
      badges: ['Verified', 'Elite Trader'],
      rating: 5,
      date: 'Feb 2026',
      text: "TopTierTrader lives up to its name. The infrastructure is institutional-grade, the rules are clear and professional, and the payouts are genuinely reliable. I manage a $500K account through them and my monthly withdrawals have never been delayed. This is the prop firm you graduate to when you're serious about professional trading. No gimmicks, no games — just proper funding for proper traders.",
      helpful: 234,
    },
    {
      name: 'Sophie W.',
      initials: 'SW',
      color: 'bg-amber-600',
      badges: ['Verified', 'cTrader User'],
      rating: 5,
      date: 'Jan 2026',
      text: "The cTrader support at TopTierTrader is excellent and relatively rare among prop firms. My algorithmic trading strategy works perfectly on their cTrader environment. Evaluation completed in 3 weeks, funding received immediately. Three payouts completed without any issues. This is simply one of the best prop firms operating right now — highly professional in every aspect.",
      helpful: 187,
    },
    {
      name: 'Ryan K.',
      initials: 'RK',
      color: 'bg-yellow-500',
      badges: ['Verified'],
      rating: 4,
      date: 'Dec 2025',
      text: "TopTierTrader's reputation for payout reliability is absolutely earned. My first withdrawal was processed same day. The challenge pricing is slightly higher than budget alternatives but you're paying for reliability, professional infrastructure, and a firm with a proven track record. For serious traders who want minimal risk of prop firm drama, TopTierTrader is the safe choice.",
      helpful: 156,
    },
  ],
};
